<div class="privacyPolicy-container">
  <iframe src="https://www.evolftech.com/privacy-notice-2/"
          style="width: 100%; height: 100vh; "></iframe>
</div>
